import { Check } from 'lucide-react';

/**
 * VerifiedBadge — solid brand-blue circle with a white check.
 * When the user also has `liveness_verified` badge, we add a green ring
 * around the badge to signal higher-trust "live verified" status.
 *
 * Renders nothing if the user's badges list does not contain 'verified'.
 *
 * Usage: <VerifiedBadge badges={profile.badges} size={18} />
 */
export default function VerifiedBadge({ badges, size = 16, className = '', ...rest }) {
  if (!Array.isArray(badges) || !badges.includes('verified')) return null;
  const stroke = Math.max(2.5, size * 0.22);
  const isLive = badges.includes('liveness_verified');
  const ringStyle = isLive
    ? { boxShadow: '0 0 0 1.5px #15803D, 0 1px 4px -1px rgba(21,128,61,0.55)' }
    : { boxShadow: '0 1px 4px -1px rgba(30,79,216,0.55)' };
  return (
    <span
      aria-label={isLive ? 'Live Verified' : 'Verified'}
      title={isLive ? 'Live Verified — passed liveness challenge' : 'Verified'}
      data-testid={rest['data-testid'] || (isLive ? 'liveness-verified-badge' : 'verified-badge')}
      className={`inline-flex items-center justify-center rounded-full bg-[#1E4FD8] flex-shrink-0 ${className}`}
      style={{ width: size, height: size, ...ringStyle }}
    >
      <Check size={Math.round(size * 0.72)} strokeWidth={stroke} className="text-white" />
    </span>
  );
}
